import moment from 'moment';
import React from 'react';
import styled from './styled';

interface LogCreationDetailsProps {
  name: string;
  date: Date;
  assetPath: string;
}

export const LogCreationDetails: React.FC<LogCreationDetailsProps> = ({
  name,
  date,
  assetPath,
}) => {
  return (
    <>
      <CreationDetails>
        <PrimaryText>{name}</PrimaryText>
        <SecondaryText>{`Created ${moment(date).format('MMM Do, YYYY h:mm a')}`}</SecondaryText>
      </CreationDetails>
      <Preferences>
        <SecondaryText>{(assetPath ?? '').split('\\').join(' | ')}</SecondaryText>
      </Preferences>
    </>
  );
};

const CreationDetails = styled.View`
  background-color: #fff;
  margin-bottom: 2px;
  padding: 10px;
`;

const Preferences = styled.View`
  background-color: #fff;
  margin-bottom: 2px;
  padding: 10px;
`;

const PrimaryText = styled.Text`
  font-size: 20px;
  color: #5a5a5a;
`;

const SecondaryText = styled.Text`
  font-size: 15px;
  color: #5a5a5a;
`;
